import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { CREATE_DMX_PROFILE } from './actionTypes';
import { createDmxProfileSuccessful, createDmxProfileFailed } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* createProfile({ payload: { profile } }) {
  try {
    const response = yield call(dmxAPI.createProfile, profile.token, profile);
    if (response.message) {
      yield put(createDmxProfileSuccessful(response.message));
    } else throw response.error;
  } catch (error) {
    yield put(createDmxProfileFailed(error));
  }
}

export function* watchCreateDmxProfile() {
  yield takeEvery(CREATE_DMX_PROFILE, createProfile);
}

function* createDmxProfileSaga() {
  yield all([fork(watchCreateDmxProfile)]);
}

export default createDmxProfileSaga;
